module.exports = __webpack_public_path__ + "static/media/LockErrorIcon.f44fc79b.svg";